








import { Vue, Component, Prop } from "vue-property-decorator";

// Types
import { IMenuRoute } from "@/models/routes";

@Component({
  components: {
    "order-view": () => import("@/components/app/global/orders/orderView.vue")
  }
})
export default class AdminOrderView extends Vue {
  // Props

  @Prop({ default: () => () => [] })
  public routes!: () => IMenuRoute[];

  // Computed

  public get orderId() {
    return this.$_.get(this.$route.params, "orderId", null);
  }
}
